import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import './Product.css'; // 導入樣式
import concept from '../assets/images/concept_of_kengine.png'; 
import filter from '../assets/images/filter_concept.png'
import future from '../assets/images/future.png'; 

function Product() {
  const { t } = useTranslation();
  // 為需要滾動到的區塊創建一個 ref
  const product1Ref = useRef(null);

  // 滾動到指定區塊的函數
  const scrollToSection = (ref) => {
    ref.current.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="product-page">
      {/* 左側導航列表 */}
      <div className="product-list">
        <ul>
          {/* 點擊列表項時滾動到對應的產品區塊 */}
          <li onClick={() => scrollToSection(product1Ref)}>{t('product_km.title')}</li>
          {/* 未來可以添加更多產品項 */}
        </ul>
      </div>

      {/* 右側產品詳情內容 */}
      <div className="product-details">
        <section ref={product1Ref} className="product-section">
          {/* 產品標題和描述 */}
          <h2>{t('product_km.title')}</h2>
          <p>{t('product_km.description')}</p>
          <p>{t('product_km.features_intro')}</p>
          
          {/* 特性一 */}
          <h3>{t('product_km.feature1_title')}</h3>
          <p>{t('product_km.feature1_description')}</p>
          <img src={concept} alt="kengine concept" />
          
          {/* 特性二 */}
          <h3>{t('product_km.feature2_title')}</h3>
          <p>{t('product_km.feature2_description')}</p>
          
          {/* 特性三 */}
          <h3>{t('product_km.feature3_title')}</h3>
          <img src={filter} alt="kengine filter" />
          <p>{t('product_km.feature3_description')}</p>

          {/* 應用場景 */}
          <h3>{t('product_km.application_title')}</h3>
          <img src={future} alt="kengine future support" />
          <p>{t('product_km.application_description')}</p>
        </section>
        {/* 未來可以添加更多產品區塊 */}
      </div>
    </div>
  );
}

export default Product;